export default "__VITE_PUBLIC_ASSET__0660367f__"